var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-message-wrapper",
      class: { repliedMessage: _vm.isRepliedMessage() },
    },
    [
      _c(
        "div",
        {
          staticClass: "sc-message",
          class:
            ((_obj = {
              "w-100": _vm.message.type.match(
                /^(text|image|asset|audio|idle-time|conversation-separator|location|chatbot-image|chatbot-gallery|chatbot-button|chatbot-quick-reply|chatbot-get-location|day-separator)$/
              ),
            }),
            (_obj[_vm.message.type] = true),
            (_obj["chatbot-debug"] = _vm.message.type === "chatbot-debug"),
            (_obj.selected = _vm.showContextMenu),
            _obj),
          style: { width: _vm.message.type === "divider" ? "auto" : "100%" },
          on: {
            contextmenu: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.openContextMenu.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              ref: "contextWrapper",
              staticClass: "sc-message--content",
              class: {
                sent: !_vm.replyMode && _vm.message.position === "right",
                received:
                  !_vm.replyMode &&
                  _vm.message.position !== "right" &&
                  _vm.message.type !== "system",
                system: !_vm.replyMode && _vm.message.type === "system",
              },
            },
            [
              _vm._t(
                "user-avatar",
                function () {
                  return [
                    _vm.showAvatar &&
                    _vm.message.type !== "system" &&
                    _vm.authorName !== undefined
                      ? _c("Avatar", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end' }",
                            },
                          ],
                          staticStyle: {
                            color: "white",
                            "font-size": "15px",
                            "margin-right": "15px",
                            cursor: "default",
                          },
                          attrs: {
                            size: 30,
                            username: _vm.authorName,
                            src: _vm.getAgentImage,
                            content: _vm.authorName,
                          },
                        })
                      : _vm._e(),
                  ]
                },
                { message: _vm.message, user: _vm.user }
              ),
              _vm._v(" "),
              _vm.message.type === "day-separator"
                ? _c("DailySeparator", {
                    attrs: { "created-date": _vm.message.raw.createdDate },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.message, "raw.isDeleted")
                ? _c("DeletedInfoMessage", {
                    attrs: {
                      "is-chat-window": _vm.isChatWindow,
                      "extended-style": _vm.extendedStyle(),
                      "is-colored": _vm.isColored && _vm.isRight,
                      message: _vm.message,
                      messageColors: _vm.determineMessageColors,
                      "disable-translation": _vm.disableTranslation,
                      "reply-mode": _vm.replyMode,
                    },
                    on: {
                      remove: function ($event) {
                        return _vm.$emit("remove")
                      },
                    },
                  })
                : _vm.message.type === "text"
                ? _c("TextMessage", {
                    attrs: {
                      "is-chat-window": _vm.isChatWindow,
                      "is-private-message": _vm.isPrivateMessage,
                      "extended-style": _vm.extendedStyle(),
                      "is-colored": _vm.isColored && _vm.isRight,
                      message: _vm.message,
                      messageColors: _vm.determineMessageColors,
                      "disable-translation": _vm.disableTranslation,
                      "reply-mode": _vm.replyMode,
                      visitorId: _vm.visitorId,
                    },
                    on: {
                      remove: function ($event) {
                        return _vm.$emit("remove")
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scopedProps) {
                            return [
                              _vm._t("text-message-body", null, {
                                me: scopedProps.me,
                                message: scopedProps.message,
                                messageColors: scopedProps.messageColors,
                                messageText: scopedProps.messageText,
                              }),
                            ]
                          },
                        },
                        {
                          key: "text-message-toolbox",
                          fn: function (scopedProps) {
                            return [
                              _vm._t("text-message-toolbox", null, {
                                me: scopedProps.me,
                                message: scopedProps.message,
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm.isAudioMessage()
                ? _c("VoiceMessage", {
                    attrs: {
                      data: _vm.message.raw,
                      "chat-message": _vm.message,
                    },
                    on: {
                      "open-gallery": function ($event) {
                        return _vm.$emit("open-gallery", $event)
                      },
                    },
                  })
                : _vm.isVideoMessage()
                ? _vm._m(0)
                : _vm.message.type === "image"
                ? _vm._m(1)
                : _vm.message.type === "asset"
                ? _c("AssetMessage", {
                    attrs: {
                      message: _vm.message,
                      "extended-style": _vm.extendedStyle(),
                      "message-colors": _vm.determineMessageColors,
                    },
                    on: {
                      "open-gallery": function ($event) {
                        return _vm.$emit("open-gallery", $event)
                      },
                    },
                  })
                : _vm.message.type === "emoji"
                ? _c("EmojiMessage", { attrs: { data: _vm.message.data } })
                : _vm.message.type === "file"
                ? _c("FileMessage", {
                    attrs: {
                      data: _vm.message.data,
                      messageColors: _vm.determineMessageColors,
                    },
                  })
                : _vm.message.type === "typing"
                ? _c("TypingMessage", {
                    attrs: { messageColors: _vm.determineMessageColors },
                  })
                : _vm.message.type === "idle-time"
                ? _c("IdleIndicatorMessage", {
                    attrs: {
                      "start-timestamp": _vm.message.data.startTimestamp,
                      "is-live": _vm.message.data.isLive,
                    },
                  })
                : _vm.message.type === "conversation-separator"
                ? _c("ChatSeparatorMessage", {
                    attrs: { "created-date": _vm.message.raw.createdDate },
                  })
                : _vm.message.type === "load-more"
                ? _c("LoadMoreMessage", {
                    attrs: {
                      "conversation-id": _vm.getConversationId(),
                      "contact-id": _vm.visitorId,
                    },
                  })
                : _vm.message.type === "voice-agent-call"
                ? _c("VoiceAgentCallMessage", {
                    attrs: {
                      message: _vm.message,
                      messageColors: _vm.determineMessageColors,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.message.type === "system" && _vm.shouldShowSystem
                ? _c(
                    "SystemMessage",
                    {
                      attrs: {
                        data: _vm.message.data,
                        messageColors: _vm.systemMessageColorsStyle(),
                      },
                    },
                    [
                      _vm._t("system-message-body", null, {
                        message: _vm.message.data,
                      }),
                    ],
                    2
                  )
                : _vm.message.type === "divider"
                ? _c("a-divider", { staticClass: "daysDivider" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.message.data.meta.split(" - ")[0]) +
                        "\n            "
                    ),
                  ])
                : _vm.message.type === "location"
                ? _c("LocationMessage", { attrs: { message: _vm.message } })
                : _vm.message.type === "chatbot-image"
                ? _c("BotImageMessage", {
                    attrs: { data: _vm.message },
                    on: {
                      "open-gallery": function ($event) {
                        return _vm.$emit("open-gallery", $event)
                      },
                    },
                  })
                : _vm.message.type === "chatbot-file"
                ? _c("BotFileMessage", {
                    attrs: {
                      data: _vm.message,
                      "extended-style": _vm.extendedStyle(),
                      "message-colors": _vm.determineMessageColors,
                    },
                    on: {
                      "open-gallery": function ($event) {
                        return _vm.$emit("open-gallery", $event)
                      },
                    },
                  })
                : _vm.message.type === "chatbot-gallery"
                ? _c("BotGalleryMessage", {
                    attrs: {
                      data: _vm.message.raw.payload,
                      "conversation-id": _vm.getConversationId(),
                      "last-clicked-button": _vm.message.raw.lastClickedButton,
                    },
                  })
                : _vm.message.type === "chatbot-button"
                ? _c("BotButtonMessage", {
                    attrs: {
                      data: _vm.message.raw.payload,
                      "conversation-id": _vm.getConversationId(),
                      "last-clicked-button": _vm.message.raw.lastClickedButton,
                    },
                  })
                : _vm.message.type === "chatbot-get-location"
                ? _c("GetLocationMessage", {
                    attrs: {
                      message: _vm.message,
                      "conversation-id": _vm.getConversationId(),
                    },
                  })
                : _vm.message.type === "select-reservation-day"
                ? _c("SelectReservationDay", {
                    attrs: { data: _vm.message.raw.payload },
                  })
                : _vm.message.type === "user-email"
                ? _c("MailMessage", { attrs: { message: _vm.message } })
                : _vm.message.type === "user-sms"
                ? _c("SMSMessage", { attrs: { message: _vm.message } })
                : _vm.message.type === "chatbot-quick-reply"
                ? _c("BotQuickReplyMessage", {
                    attrs: {
                      messageColors: _vm.determineMessageColors,
                      "extended-style": _vm.extendedStyle(),
                      "is-colored": _vm.isColored && _vm.isRight,
                      data: _vm.message.raw.payload,
                      message: _vm.message,
                      meta: _vm.message.data.meta,
                      meta2: _vm.message.data.meta2,
                      "conversation-id": _vm.getConversationId(),
                      "last-clicked-button": _vm.message.raw.lastClickedButton,
                    },
                  })
                : _vm.message.type === "chatbot-debug" && _vm.debugModeEnabled
                ? _c("ChatbotDebugMessage", { attrs: { message: _vm.message } })
                : _vm.message.type === "whatsapp-business-api-template"
                ? _c("WABATemplateMessage", {
                    attrs: {
                      data: _vm.message.raw,
                      "conversation-id": _vm.getConversationId(),
                      "last-clicked-button": _vm.message.raw.lastClickedButton,
                    },
                  })
                : _vm.message.type === "meta-post"
                ? _c("MetaPostMessage", {
                    attrs: {
                      data: _vm.message.raw,
                      "conversation-id": _vm.getConversationId(),
                      "last-clicked-button": _vm.message.raw.lastClickedButton,
                    },
                  })
                : _vm.message.type === "trendyol-product"
                ? _c("TrendyolProductMessage", {
                    attrs: {
                      data: _vm.message.raw,
                      "conversation-id": _vm.getConversationId(),
                    },
                  })
                : _vm.message.type === "json"
                ? _c("JsonMessage", {
                    attrs: {
                      message: _vm.message,
                      "extended-style": _vm.extendedStyle(),
                      "message-colors": _vm.determineMessageColors,
                      "reply-mode": _vm.replyMode,
                      right: _vm.message.position === "right",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasReactions
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { followCursor: true, placement: "top" },
                          expression:
                            "{ followCursor: true, placement: 'top' }",
                        },
                      ],
                      staticClass: "message-reactions",
                      class: {
                        "reactions-left": _vm.message.position === "right",
                        "reactions-right": _vm.message.position !== "right",
                      },
                      attrs: { content: _vm.getTotalReactionsTooltip() },
                      on: { click: _vm.openReactionModal },
                    },
                    [
                      _vm._l(_vm.getTopReactions, function (emoji) {
                        return _c(
                          "span",
                          { key: emoji, staticClass: "reaction-emoji" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(emoji) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.totalReactionsCount > 2
                        ? _c("span", { staticClass: "reaction-total-count" }, [
                            _vm._v(_vm._s(_vm.totalReactionsCount)),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMessageEdited
                ? _c(
                    "div",
                    {
                      staticClass: "message-edited-indicator",
                      class: {
                        "edited-right": _vm.message.position === "right",
                        "edited-left": _vm.message.position !== "right",
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("edit"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "edited-text" }, [
                        _vm._v(_vm._s(_vm.getEditedText())),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.message.position === "right" &&
              !_vm.shouldDismissMessage &&
              _vm.message.type !== "chatbot-debug" &&
              !_vm.isPrivateMessage
                ? _c(
                    "span",
                    {
                      staticClass: "checkMark",
                      style: {
                        color:
                          _vm.$_.get(_vm.message, "raw.status", "sent") ===
                          "pending"
                            ? "#ffc500"
                            : "lime",
                      },
                    },
                    [_vm._v("✓")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldDismissMessage &&
              _vm.isRight &&
              _vm.$_.get(_vm.message, "raw.status", "sent") === "pending" &&
              [
                "text",
                "audio",
                "image",
                "asset",
                "emoji",
                "file",
                "location",
              ].includes(_vm.message.type)
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "notSend",
                      attrs: {
                        content: _vm.$t("message.removePendingMessage"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.removePendingMsg(
                            _vm.message.raw.uniqMessageId
                          )
                        },
                      },
                    },
                    [_vm._v("\n                x\n            ")]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.showFallbackMeta && _vm.fallbackMetaLineText
            ? _c(
                "div",
                {
                  staticClass: "sc-message-fallback-meta",
                  class: {
                    "fallback-meta-right": _vm.message.position === "right",
                    "fallback-meta-left": _vm.message.position !== "right",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: _vm.fallbackMetaTippyOptions,
                          expression: "fallbackMetaTippyOptions",
                        },
                      ],
                      staticClass: "fallback-meta-text",
                    },
                    [_vm._v(_vm._s(_vm.fallbackMetaLineText))]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.aiModelText
            ? _c("div", { staticClass: "ai-model-info" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("auto_awesome"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.aiModelText))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.whatsappDeliveryStatus().visible && !_vm.isPrivateMessage
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  staticClass: "wp-delivery",
                  class: {
                    "wp-delivery-left": _vm.message.position !== "right",
                  },
                  attrs: {
                    content:
                      "Whatsapp Hata Mesajları hakkında detaylı bilgi almak için tıklayınız.",
                  },
                  on: { click: _vm.handleErrorClick },
                },
                [
                  _c("WhatsappIcon", {
                    staticClass: "wp-delivery-icon",
                    attrs: {
                      color: _vm.whatsappDeliveryStatus().pending
                        ? "gray"
                        : _vm.whatsappDeliveryStatus().delivered
                        ? "green"
                        : "red",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "delivery-status",
                      style: {
                        color: _vm.whatsappDeliveryStatus().pending
                          ? "gray"
                          : _vm.whatsappDeliveryStatus().delivered
                          ? "green"
                          : "red",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.whatsappDeliveryStatus().tooltip) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.pendingWhatsappMessages[
                    _vm.$_.get(_vm.message, "raw.uniqMessageId")
                  ]
                    ? _c("i", { staticClass: "resent-label" }, [
                        _vm._v("\n                Gönderiliyor\n            "),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.metaDeliveryStatus().visible && !_vm.isPrivateMessage
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  staticClass: "wp-delivery",
                  class: {
                    "wp-delivery-left": _vm.message.position !== "right",
                  },
                  attrs: { content: _vm.metaDeliveryStatus().tooltip },
                },
                [
                  _vm.metaDeliveryStatus().platform === "instagram"
                    ? _c("InstagramIcon", {
                        staticClass: "wp-delivery-icon instagram",
                        attrs: {
                          color: _vm.metaDeliveryStatus().pending
                            ? "gray"
                            : _vm.metaDeliveryStatus().delivered
                            ? "green"
                            : "red",
                        },
                      })
                    : _vm.metaDeliveryStatus().platform === "messenger"
                    ? _c("FacebookIcon", {
                        staticClass: "wp-delivery-icon",
                        attrs: {
                          color: _vm.metaDeliveryStatus().pending
                            ? "gray"
                            : _vm.metaDeliveryStatus().delivered
                            ? "green"
                            : "red",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "delivery-status",
                      style: {
                        color: _vm.metaDeliveryStatus().pending
                          ? "gray"
                          : _vm.metaDeliveryStatus().delivered
                          ? "green"
                          : "red",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.metaDeliveryStatus().tooltip) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      (_vm.contextMenu || _vm.hasActorDetail) && _vm.isContextEnabled()
        ? _c(
            "context-menu",
            {
              staticClass: "context-menu",
              style: {
                top: _vm.contextMenuPosition.y + "px !important",
                left: _vm.contextMenuPosition.x + "px !important",
                display: _vm.showContextMenu ? "block" : "none",
              },
              attrs: {
                target: _vm.contextMenuTarget,
                show: _vm.showContextMenu,
              },
              on: {
                "update:show": function (show) {
                  return (_vm.showContextMenu = show)
                },
                contextmenu: function ($event) {
                  $event.preventDefault()
                  return _vm.openContextMenu.apply(null, arguments)
                },
                dblclick: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "context-menu-content" },
                [
                  _vm.hasActorDetail
                    ? _c(
                        "div",
                        {
                          staticClass: "item",
                          on: { click: _vm.goToActorBlock },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" location_searching "),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.actorBlockText))]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask && _vm.isDownloadEnabled()
                    ? _c(
                        "div",
                        {
                          staticClass: "item",
                          on: {
                            click: function () {
                              return _vm.downloadFile()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" download "),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("tables.download"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask && _vm.isCopyEnabled()
                    ? _c(
                        "div",
                        {
                          staticClass: "item",
                          on: {
                            click: function () {
                              return _vm.onContextMenuSelected("copy")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" content_copy "),
                          ]),
                          _vm._v(" "),
                          _vm.message.type === "image"
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.copyImage"))),
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.copyText"))),
                              ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask && !_vm.isCommentMessage()
                    ? _c(
                        "div",
                        {
                          staticClass: "item",
                          on: {
                            click: function () {
                              return _vm.onContextMenuSelected("reply")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" reply "),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("message.replyMessage"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item", on: { click: _vm.createTask } },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" add_task "),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("task.createTask")))]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask
                    ? _c(
                        "div",
                        {
                          staticClass: "item",
                          on: {
                            click: function ($event) {
                              _vm.newEventModalVisible = true
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" edit_calendar "),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("message.createEvent"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask && _vm.isTranslateActive()
                    ? _c(
                        "div",
                        {
                          staticClass: "item",
                          on: {
                            click: function ($event) {
                              return _vm.onContextMenuSelected("translate")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" translate "),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("message.translateVisitorMessage"))
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask && _vm.isCommentMessage()
                    ? _c(
                        "div",
                        {
                          staticClass: "item",
                          on: { click: _vm.replyCommentAction },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" reply "),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Yorumu Yanıtla")]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask
                    ? _vm._l(
                        _vm.categorizedMessageAutomations,
                        function (category) {
                          return _c(
                            "div",
                            {
                              key: category.name,
                              staticClass: "item submenu-item",
                              on: {
                                mouseenter: function ($event) {
                                  return _vm.handleSubmenuHover(
                                    $event,
                                    category.name
                                  )
                                },
                                mouseleave: _vm.handleSubmenuLeave,
                              },
                            },
                            [
                              category.icon
                                ? _c(
                                    "i",
                                    {
                                      staticClass: "material-icons myIcon",
                                      style: {
                                        color:
                                          "var(--color-icon-primary-default)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(category.icon) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "i",
                                    {
                                      staticClass: "material-icons myIcon",
                                      style: {
                                        color:
                                          "var(--color-icon-primary-default)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    folder\n                "
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(category.name))]),
                              _vm._v(" "),
                              _c(
                                "i",
                                { staticClass: "material-icons submenu-arrow" },
                                [_vm._v("chevron_right")]
                              ),
                              _vm._v(" "),
                              _vm.currentSubmenuPosition[category.name]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "submenu-content",
                                      style:
                                        _vm.currentSubmenuPosition[
                                          category.name
                                        ],
                                      on: {
                                        mouseenter: _vm.cancelSubmenuLeave,
                                        mouseleave: _vm.handleSubmenuLeave,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "submenu-inner" },
                                        _vm._l(
                                          category.automations,
                                          function (automation) {
                                            return _c(
                                              "div",
                                              {
                                                key: automation._id,
                                                staticClass: "item",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return function () {
                                                      return _vm.runAutomation(
                                                        automation
                                                      )
                                                    }.apply(null, arguments)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons myIcon",
                                                    style: {
                                                      color:
                                                        "var(--color-icon-primary-default)",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                power_settings_new\n                            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(automation.name)
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask &&
                  _vm.categorizedMessageAutomations.length > 0 &&
                  _vm.generalMessageAutomations.length > 0
                    ? _c("div", { staticClass: "item-divider" })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.contextMenuOnlyCreateTask
                    ? _vm._l(
                        _vm.generalMessageAutomations,
                        function (automation) {
                          return _c(
                            "div",
                            {
                              key: automation._id,
                              staticClass: "item",
                              on: {
                                click: function () {
                                  return _vm.runAutomation(automation)
                                },
                              },
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons myIcon",
                                  style: {
                                    color: "var(--color-icon-primary-default)",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        power_settings_new\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(automation.name))]),
                            ]
                          )
                        }
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.message.type === "conversation-separator" &&
      _vm.showSeparatorContextMenu
        ? _c(
            "div",
            {
              staticClass: "separator-context-menu",
              style: {
                top: _vm.separatorContextMenuPosition.y + "px",
                left: _vm.separatorContextMenuPosition.x + "px",
              },
              on: {
                mouseleave: function ($event) {
                  _vm.showSeparatorContextMenu = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "item", on: { click: _vm.copyChatId } },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("content_copy"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.copyChatId")))]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNewMessage(_vm.message)
        ? _c("a-divider", { staticClass: "newMessageDivider" }, [
            _vm._v(_vm._s(_vm.$t("message.unreadMessages")) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.newEventModalVisible
        ? _c("CreateEventModal", {
            attrs: {
              eventSummary: _vm.message.data.text,
              calendarList: _vm.calendarList,
            },
            on: {
              close: function ($event) {
                _vm.newEventModalVisible = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showZohoRecordPicker
        ? _c("ZohoRecordPicker", {
            attrs: {
              phone: _vm.activeContactPhone,
              module: _vm.zohoModule,
              contactId: _vm.activeContactZohoContactId,
            },
            on: {
              selected: _vm.handleZohoRecordSelected,
              cancel: _vm.handleZohoRecordPickerCancel,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showReactionModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Reaksiyonlar",
                "show-footer": false,
                medium: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.showReactionModal = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "reactions-modal-content" },
                _vm._l(_vm.groupedReactions, function (reactionGroup, emoji) {
                  return _c(
                    "div",
                    { key: emoji, staticClass: "reaction-group" },
                    [
                      _c("div", { staticClass: "reaction-group-header" }, [
                        _c("span", { staticClass: "reaction-group-emoji" }, [
                          _vm._v(_vm._s(emoji)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "reaction-group-count" }, [
                          _vm._v(_vm._s(reactionGroup.length)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "reaction-users-list" },
                        _vm._l(reactionGroup, function (reaction) {
                          return _c(
                            "div",
                            {
                              key: reaction.author,
                              staticClass: "reaction-user",
                            },
                            [
                              _c("div", { staticClass: "reaction-user-info" }, [
                                _c(
                                  "span",
                                  { staticClass: "reaction-user-name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        reaction.authorName || "Bilinmeyen"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "reaction-timestamp" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatReactionTime(
                                          reaction.timestamp
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showErrorModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("auto.whatsappErrorDetailsTitle"),
                "show-footer": false,
                xlarge: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.showErrorModal = false
                },
              },
            },
            [
              _c("WABAErrorCodes", {
                attrs: { "default-selected-error": _vm.currentError },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("VideoMessage", {
      attrs: { data: _vm.message.data, message: _vm.message },
      on: {
        "open-gallery": function ($event) {
          return _vm.$emit("open-gallery", $event)
        },
      },
    })
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ImageMessage", {
      attrs: {
        "extended-style": _vm.extendedStyle(),
        message: _vm.message,
        "message-colors": _vm.determineMessageColors,
        received:
          !_vm.replyMode &&
          _vm.message.position !== "right" &&
          _vm.message.type !== "system",
      },
      on: {
        "open-gallery": function ($event) {
          return _vm.$emit("open-gallery", $event)
        },
      },
    })
  },
]
render._withStripped = true

export { render, staticRenderFns }